import React, { useEffect, useState } from "react";
import { fetchCatalog } from "@/lib/api";
import Flipbook from "@/components/catalog/Flipbook";

export default function CatalogView() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchCatalog()
      .then(setData)
      .catch(() => setError("Não foi possível carregar o catálogo."));
  }, []);

  if (error) {
    return (
      <div className="min-h-[100dvh] flex items-center justify-center text-[var(--nude)] font-body text-sm">
        {error}
      </div>
    );
  }

  if (!data) {
    return (
      <div
        className="min-h-[100dvh] flex flex-col items-center justify-center gap-4"
        data-testid="catalog-loading"
      >
        <span className="font-heading text-gold-metallic text-6xl shimmer">BR</span>
        <span className="font-body text-[0.6rem] uppercase tracking-[0.35em] text-[var(--muted)]">
          Studio da Beleza
        </span>
      </div>
    );
  }

  return <Flipbook studio={data.studio} modalities={data.modalities} />;
}
